"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Router = _interopRequireDefault(require("../../../../utils/Router"));
var _SessionHandler = _interopRequireDefault(require("../../../../utils/SessionHandler"));
var getPreselectedContractAccountId = function getPreselectedContractAccountId(contracts) {
  var id = _Router.default.getParameter('contractAccId');
  if (!contracts || contracts.length === 0) {
    return '';
  }
  if (id) {
    var selectedContract = contracts.find(function (contract) {
      return contract.contractAccountId === id;
    });
    if (selectedContract) {
      _SessionHandler.default.setPermissions(contracts, id);
      return id;
    }
    _Router.default.setParameter({
      contractAccId: ''
    });
  }
  _SessionHandler.default.setPermissions(contracts, contracts[0].contractAccountId);
  return contracts[0].contractAccountId;
};
var _default = exports.default = getPreselectedContractAccountId;